import { useCallback, useState, useEffect } from 'react';
import { Folder } from '../../../../types';
import { getFolderPathById } from '../../FoldersList.utils';

type UseFolderListExpandedItemsProps = {
  expandedItemsKey: string;
  activeFolderId: Folder['id'];
  folders: Folder[];
  foldersMap: Map<string, Folder>;
};

export const useFolderListExpandedItems = ({
  expandedItemsKey,
  activeFolderId,
  folders,
  foldersMap
}: UseFolderListExpandedItemsProps) => {
  const [expandedItems, setExpandedItems] = useState<string[]>(() => {
    return getFolderListExpandedItems(expandedItemsKey) || [];
  });

  const handleItemExpansionToggle = useCallback(
    (folderListExpandedItems: string[]) => {
      setExpandedItems(folderListExpandedItems);
      setFolderListExpandedItems(expandedItemsKey, folderListExpandedItems);
    },
    [expandedItemsKey]
  );

  useEffect(() => {
    if (activeFolderId) {
      const activeFolderPath = getFolderPathById({ folders, folderId: activeFolderId });
      if (activeFolderPath) {
        const activeFolderParents = activeFolderPath.slice(0, -1);
        const newExpandedItems = expandedItems.slice();
        activeFolderParents.forEach((folderId) => {
          if (foldersMap.has(folderId) && !newExpandedItems.includes(folderId)) {
            newExpandedItems.push(folderId);
          }
        });
        handleItemExpansionToggle(newExpandedItems);
      }
    }
  }, [activeFolderId, folders, foldersMap]);

  return { expandedItems, handleItemExpansionToggle };
};

export function getFolderListExpandedItems(key: string): string[] | null {
  return JSON.parse(window.localStorage.getItem(key) ?? 'null') as string[];
}

export function setFolderListExpandedItems(expandedItemsKey: string, folderListExpandedItems: string[]) {
  window.localStorage.setItem(expandedItemsKey, JSON.stringify(folderListExpandedItems));
}
